import { Control } from '@Common/Controls/Controls';
import { IControlParameters } from '@Common/Controls/BaseControl';

export interface ILinkParamters extends IControlParameters {
    text?: string;
    href?: string;
    enabled?: boolean;
    color?: string;
}

export interface Link extends Control {
    click(fn: () => void);

    setText(text: string): void;

    visible(value?: boolean): boolean;
}

export function link(param: ILinkParamters): Link {
    param = $.extend(
        {
            css: null,
            className: '',
            width: 'auto',
            height: 'auto',

            text: strings.link.defaultText,
            href: '#',
            enabled: true,
            color: undefined
        },
        param
    );

    let click = _.noop;
    let enabled = param.enabled;
    const color = param.color ? 'color:' + param.color : '';
    const root = $('<a href="' + param.href + '" style="' + color + '">' + param.text + '</a>').click(function (e) {
        e.preventDefault();

        if (enabled) {
            click(e);
        }
    });
    if (param.className) {
        root.addClass(param.className);
    }

    setState(enabled);

    function setState(en) {
        enabled = en;
        root.toggleClass('disabled', !enabled);
    }

    function visible(isVisible) {
        root.toggleClass('hidden', isVisible === false);
        return root.hasClass('hidden');
    }

    return {
        setState: setState,
        visible: visible,
        getControl: function () {
            return root;
        },
        click: function (fn) {
            if ($.isFunction(fn)) {
                click = fn;
            }
        },
        setText: function (text) {
            root.text(text);
        }
    };
}
